export const BASE_PATH = "https://api.tugo.app"
// export const BASE_PATH = "http://localhost:9000" 
export const appIDFacebook = "915713235938789" 
export const API_COUNTRIES =  "https://restcountries.com/v3.1/all"
